import React, { useState, useEffect } from 'react'
import style from './style.module.css'

const {
  bodyOpen,
  body,
  arrow,
  arrowOpen,
  head,
  headOpen,
  titleCollapse,
  titleCollapseOpen,
  titleSmall,
  arrowSmall,
} = style

const Collapse = ({
  title,
  children,
  id,
  openTab,
  onTab,
  small
}) => {
  /**
   * Estado inicial del componente
   */
  const [open, setOpen] = useState(openTab)

  useEffect(() => {
    setOpen(openTab)
  }, [openTab])

  /**
   * Obtengo el estilo para mostrar el contenido
   * del tab según su estado
   */
  const getContentStyle = () => {
    return open ? `${body} ${bodyOpen}` : body
  }

  /**
   * Estilo para la flecha según estado del componente
   */
  const getArrowStyle = () => {
    return open ? `${arrow} ${arrowOpen}` : arrow
  }

  const getArrowStyleSmall = () => {
    return small ? arrowSmall : ''
  }

  /**
   * Función que cambia el estado del componente
   * al dar click
   */
  const onCollapse = () => {
    setOpen(!open)
    onTab(id)
  }

  const getTitleStyle = () => {
    return open ? `${titleCollapse} ${titleCollapseOpen}` : titleCollapse
  }
  const getTitleStyleSmall = () => {
    return small ? titleSmall : ''
  }

  const getHeadStyle = () => {
    return open ? `${head} ${headOpen}` : head
  }

  /**
   * Render del componente
   */
  return (
    <React.Fragment>
      <div className={getHeadStyle()}>
      <div className={`${getTitleStyle()} ${getTitleStyleSmall()}`}>
        {title}
      </div>
      <div
        className={`${getArrowStyle()} ${getArrowStyleSmall()}`}
        onClick={onCollapse}
      />
      </div>
      <div className={getContentStyle()}>
        {children}
      </div>
    </React.Fragment>
  )
}

export default Collapse
